import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createInventoryChangesSchemas } from 'shared/db/validation/schema/inventoryChanges';
import { Validator } from 'shared/db/validation/validator';
import {
    InventoryChangeRawRecord,
    InventoryChangeUpdateRawRecord,
} from 'shared/types/InventoryChange';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { InventoryChangeDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createInventoryChangesSchemas();

const addValidator = createDBEntityValidator<InventoryChangeRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<InventoryChangeUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-inventory-changes'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createInventoryChangesInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const inventoryChangesInputValidation: InventoryChangeDBValidation = {
    add: createInventoryChangesInputValidation(
        addValidator,
        validationStrategy,
    ),
    update: createInventoryChangesInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createInventoryChangesInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
